import React, {useEffect} from 'react'
import {DropdownList} from '@components/common/dropdown-list/dropdown-list'
import {Remove} from '@components/statistics/stats-reports/common'
import {Option} from '@components/common/select/select'
import {ReportBooleanFilter} from 'yougile-model'

interface OuterProps {
  filter: ReportBooleanFilter
  yesText: string
  noText: string
}

interface Props extends OuterProps {
  update: (filters: ReportBooleanFilter) => void
}

export const BooleanFilter = (props: Props) => {
  const {filter, update} = props

  useEffect(() => {
    if (!filter || filter.type === 'not-set') {
      props.update({type: 'value', value: true})
    }
  }, [])

  const opts = getOpts(props)
  const selectValue = getSelectedValue(props)

  const change = (newVal: 'any' | 'yes' | 'no') => {
    if (newVal === 'yes') {
      update({type: 'value', value: true})
    } else if (newVal === 'no') {
      update({type: 'value', value: false})
    } else {
      update(undefined)
    }
  }

  return (
    <div>
      <DropdownList
        className="w-184"
        options={opts}
        value={selectValue}
        initialOpen={!filter}
        onChange={change}
      />
      <Remove update={update} />
    </div>
  )
}

const getSelectedValue = (props: OuterProps) => {
  const {filter} = props
  const selectValue =
    !!filter && filter.type === 'value' ? (filter.value ? 'yes' : 'no') : 'any'

  return selectValue
}

const getOpts = (props: OuterProps) => {
  const {yesText, noText} = props

  const opts: Option[] = [
    {value: 'yes', label: yesText},
    {value: 'no', label: noText}
  ]

  return opts
}

export const BooleanFilterValue = (props: OuterProps) => {
  const opts = getOpts(props)
  const selectValue = getSelectedValue(props)
  const value = opts.find(opt => opt.value === selectValue)
  return <>{value?.label ?? ''}</>
}
